<template>
  <v-container >
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="doSearchMain()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <i-label :label="'Ship No : '" class="pl-2"/>
                <v-col cols="12" md="2">
                  <v-select
                    label="Ship No"
                    v-model="shipNo"
                    :items="listShipNo"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>
                <i-label :label="'Block : '" class="pl-2"/>
                <v-col cols="12" md="2">
                <v-text-field 
                    label="Block"
                    v-model="block"
                    dense
                    outlined
                    hide-details="auto"
                    :maxlength="4"
                    @input="limitInput"
                    @keyup="uppercase"
                  />                                                  
                </v-col>    
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="pa-0">
        <v-row no-gutters>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>Ship No</span>
          </v-col>
          <v-col cols="3">
             <v-text-field 
              v-model="formData.shipno" 
              dense 
              outlined 
              hide-details="auto"
              clearable
              disabled
              class="custom-text-field"
            />
          </v-col>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>Erect Block</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.erectblk" 
              dense 
              outlined 
              hide-details="auto"
              clearable
              disabled
              class="custom-text-field"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>1PE Block</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.pe1blk" 
              dense 
              outlined 
              hide-details="auto"
              clearable 
              disabled
              class="custom-text-field"
            />
          </v-col>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>Block</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.block" 
              dense 
              outlined 
              hide-details="auto"
              clearable
              disabled
              class="custom-text-field"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>Weight</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.wkvol" 
              dense 
              outlined 
              hide-details="auto"
              clearable 
              disabled
              class="custom-text-field"
            />
          </v-col>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeader">
            <span>Location</span>
          </v-col>
          <v-col cols="3"  class="locationBorder">
            <v-chip
              v-if="formData.disloc != null"
              small
              class="ml-2"
              color="green"
              text-color="white"
              @click="goToBlockYard"
            >
              {{formData.disloc}}
            </v-chip>
          </v-col>                    
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeaderBottom">
            <span>Erect Plan</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.erectpsd" 
              dense 
              outlined 
              hide-details="auto"
              clearable 
              disabled
              class="custom-text-field"
            />
          </v-col>
          <v-col cols="3" align="right" class="pr-2 pt-1 formHeaderBottom">
            <span >Erect Act</span>
          </v-col>
          <v-col cols="3">
            <v-text-field 
              v-model="formData.erectstrdt" 
              dense 
              outlined 
              hide-details="auto"
              clearable
              disabled
              class="custom-text-field"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pt-1">
        <!-- Data Table -->
        <v-card class="pa-0 mt-4">
          <v-simple-table dense class="bordered-table">
            <thead>
              <tr>
                <th class="text-center" rowspan="2">BLOCK</th>
                <th class="text-center" rowspan="2">STAGE</th>
                <th class="text-center" colspan="2">PLAN</th>
                <th class="text-center" colspan="2">ACTUAL</th>
              </tr>
              <tr>
                <th class="text-center">START</th>
                <th class="text-center">FINISH</th>
                <th class="text-center">START</th>
                <th class="text-center">FINISH</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in mergedBlockStages" >
                <tr v-if="item.rowspan">
                  <td :rowspan="item.rowspan" class="text-center bordered-cell">{{ item.block }}</td>
                  <td class="text-center bordered-cell">{{ item.stage }}</td>
                  <td class="text-center bordered-cell">{{ item.plan.start }}</td>
                  <td class="text-center bordered-cell">{{ item.plan.finish }}</td>
                  <td class="text-center bordered-cell">{{ item.actual.start }}</td>
                  <td class="text-center bordered-cell">{{ item.actual.finish }}</td>
                </tr>
                <tr v-else>
                  <td class="text-center bordered-cell">{{ item.stage }}</td>
                  <td class="text-center bordered-cell">{{ item.plan.start }}</td>
                  <td class="text-center bordered-cell">{{ item.plan.finish }}</td>
                  <td class="text-center bordered-cell">{{ item.actual.start }}</td>
                  <td class="text-center bordered-cell">{{ item.actual.finish }}</td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getBlkInfo, getBlkProcess, listAllShipNo } from '@/api/view/pp/20/v20a4030.js'

export default {
  name: 'v20a4000',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      formData: { },
      blockStages: [
              
            ],
      
      listShipNo: [],
      shipNo: '',
      block: '',
    }
  },
  computed: {
    mergedBlockStages() {
      let merged = [];
      let lastBlock = "";
      let count = 0;
      this.blockStages.forEach((item, index) => {
        if (item.block !== lastBlock) {
          count = this.blockStages.filter(b => b.block === item.block).length;
          merged.push({ ...item, rowspan: count });
          lastBlock = item.block;
        } else {
          merged.push({ ...item, rowspan: 0 });
        }
      });
      return merged;
    }
  },
  created() {
    this.setShipNo()
  },
  mounted() {
  },
  methods: {
    limitInput() {
      if (this.block.length > 4) {
        this.block = this.block.slice(0, 4); // Cắt chỉ giữ lại 4 ký tự đầu tiên
      }
    },
    uppercase() {
      this.block = this.block.toUpperCase(); // Chuyển thành chữ in hoa
    },
    goToBlockYard() {
      let data = { strShipno: this.shipNo, strBlock: this.block, selectTitle: "Yard Layout (Block Arrangement)" }; // Dữ liệu cần truyền
      this.$emit('switchToYard', data);
    },
    async doSearchMain() {
      try {
        this.openLoading('searching');

        if (!this.shipNo) {
          this.vToastify(this.$t('Please, select a Ship No'), 'warn');
          return;
        }
        if (!this.block) {
          this.vToastify(this.$t('Please, input a Block'), 'warn');
          return;
        }

        let params = {
          strShipno: this.shipNo,
          strBlock: this.block,
        };

        // Lấy thông tin Block
        try {
          const res = await getBlkInfo(params);
          if (res.list?.length) {
            const list = res.list[0];
            this.formData = {
              shipno: list.shipno,
              erectblk: list.erectblk,
              pe1blk: list.pe1blk,
              block: list.block,
              wkvol: list.wkvol,
              disloc: list.disloc,
              erectpsd: list.erectpsd,
              erectstrdt: list.erectstrdt,
              vischk: list.vischk,
              decdt: list.decdt,
            };
          }
        } catch (error) {
          console.error("Error fetching Block Info:", error);
        }

        // Lấy thông tin giai đoạn
        this.blockStages = [];
        try {
          const res = await getBlkProcess(params);
          if (res.list?.length) {
            this.blockStages = res.list.map(e => ({
              block: e.block,
              stage: e.gubun,
              plan: { start: e.wkstpldt, finish: e.wkfipldt },
              actual: { start: e.wkstdt, finish: e.wkfidt }
            }));
          }
        } catch (error) {
          console.error("Error fetching Block Process:", error);
        }
      } catch (error) {
        console.error("Unexpected error:", error);
      } finally {
        this.endLoading();
      }
    },
    async setShipNo() {
    // getShipNo
      const ship = async () => {
        await listAllShipNo().then(result => {
          result.list.forEach(item => {
            this.listShipNo.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }
      //     
      await Promise.all([ship()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },  
    
  }
}
</script>
<style scoped>
  .formHeader {
    background-color: #d4ecf8;
    font-weight: bold;
    border: 1px solid gray;
    border-bottom: 0px solid gray;
    color: black;
    font-size: 9pt;
  }
  .formHeaderBottom {
    background-color: #d4ecf8;
    font-weight: bold;
    border: 1px solid gray;
    border-bottom: 1px solid gray;
    color: black;
    font-size: 9pt;
  }
  
  .locationBorder {
    border: 1px solid gray;
  }
  /* Giữ màu chữ rõ ràng */
  .custom-text-field >>> .v-input__control {
    opacity: 1 !important; /* Giữ nguyên màu */
    border: 0px solid black !important; /* Tăng độ rõ của viền */
    border-bottom: 0px;
    background-color: #f5f5f5 !important; /* Giữ nền giống disabled */
  }

  /* Đổi màu chữ */
  .custom-text-field >>> input {
    color: black !important;
  }

  /* Tạo hiệu ứng giống button khi hover */
  .clickable-text-field >>> .v-input__control {
    cursor: pointer !important;
    border: 2px solid blue !important;
  }

  .clickable-text-field >>> .v-input__control:hover {
    background-color: #e3f2fd !important; /* Màu nền nhẹ khi hover */
  }
  /*Data table*/
  th {
    background-color: #d4ecf8;
    color: white;
    text-align: center;
    border: 1px solid gray;
  }
  .text-center {
    text-align: center;
    vertical-align: middle;
  }
  .bordered-table {
    border-collapse: collapse;
    width: 100%;
  }
  .bordered-table th, .bordered-table td {
    border: 1px solid gray;
    padding: 8px;
  }
  .bordered-cell {
    border: 1px solid gray;
  }
</style>